var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgReviewNotification = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2B4157",
    fillRule: "evenodd",
    d: "M12 16.05c.159 0 .318.038.463.113l3.769 1.97-.717-4.157c-.058-.326.051-.658.29-.889l3.035-2.936-4.203-.612c-.325-.047-.606-.25-.752-.544L12 5.201l-1.886 3.794c-.145.294-.426.497-.751.544l-4.203.612 3.036 2.936c.238.231.347.563.29.889l-.717 4.157 3.769-1.97c.144-.075.303-.113.462-.113m5.562 4.905c-.159 0-.317-.037-.462-.113l-5.1-2.664-5.098 2.664c-.338.176-.746.145-1.051-.079-.308-.224-.461-.603-.397-.978l.972-5.628-4.12-3.985c-.275-.265-.373-.663-.256-1.026.116-.363.43-.627.807-.682l5.7-.828 2.548-5.126c.338-.68 1.454-.68 1.792 0l2.546 5.126 5.701.828c.377.055.691.319.808.682.116.363.018.761-.256 1.026l-4.12 3.985.972 5.628c.063.375-.09.754-.398.978-.172.128-.38.192-.588.192",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReviewNotification, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/review_notification.4ea6576b.svg";
export { ForwardRef as ReactComponent };